import { NoopScrollStrategy } from "@angular/cdk/overlay";
import { Component } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { map } from "rxjs/operators";
import { OrdersApiService } from "src/app/api/orders-api.service";
import { LensSectionMode } from "src/app/model/configuration/configuration";
import { OrderItem } from "src/app/model/order/order";
import { NewOrderStoreService } from "src/app/new-order/new-order-store-service.service";
import { CartService } from "../../cart/cart.service";
import { LanguagePickerService } from "../../language-picker/language-picker.service";
import { MessageService } from "../../message/message.service";
import { SaveDiscardOrderDialogComponent } from "../../save-discard-order-dialog/save-discard-order-dialog.component";

@Component({
    selector: 'app-nav-new-order',
    templateUrl: './nav-new-order.component.html',
    styleUrls: ['./nav-new-order.component.scss']
})
export class NavNewOrderComponent {

    constructor(
        private dialog: MatDialog,
        private cartService: CartService,
        private router: Router,
        private newOrderStoreService: NewOrderStoreService,
        private languagePickerService: LanguagePickerService,
        private ordersApiService: OrdersApiService,
        private messages: MessageService
    ) {
        window.onbeforeunload = (event) => {
            const e = event || window.event;
            e.preventDefault();
            if (e) {
                this.saveAndGoToHome();
            }
          };
    }

    goToHome() {
        this.isNeedShowSaveDiscardModal();
    }

    private isNeedShowSaveDiscardModal() {
        let orderItems: OrderItem[] = [];
        this.cartService.getCartItems().subscribe(data => orderItems = data);

        let isNeedShowSaveDiscardModal = orderItems.some(orderItem => orderItem.isNew === true || orderItem.isUpdate === true);
        if(isNeedShowSaveDiscardModal) {
            const dialogRef = this.dialog.open( SaveDiscardOrderDialogComponent, {
                width: '650px',
                scrollStrategy: new NoopScrollStrategy()
            });
        } else {
            this.newOrderStoreService.setCopyTrialLensRight(undefined);
            this.newOrderStoreService.setCopyTrialLensLeft(undefined);

            this.router.navigate(['/home']);
        }
    }

    goToProposal() {
        this.router.navigate(['/new-order'], {fragment: 'proposal'});
        document.querySelector('#proposal').scrollIntoView();
        this.newOrderStoreService.changeLensSectionMode(LensSectionMode.HECHT_PROPOSAL);
    }

    goToFinalLens() {
        this.router.navigate(['/new-order'], {fragment: 'final-lens'});
        document.querySelector('#final-lens').scrollIntoView();
        this.newOrderStoreService.changeLensSectionMode(LensSectionMode.FINAL_LENS);
    }

    goToTrialLens() {
        this.router.navigate(['/new-order'], {fragment: 'trial-lens'});
        document.querySelector('#trial-lens').scrollIntoView();
        this.newOrderStoreService.changeLensSectionMode(LensSectionMode.TRIAL_LENS);
    }

    goToCare() {
        this.router.navigate(['/new-order'], {fragment: 'care'});
        document.querySelector('#care').scrollIntoView();
        this.newOrderStoreService.changeLensSectionMode(LensSectionMode.CARE);
    }

    goToAccessories() {
        this.router.navigate(['/new-order'], {fragment: 'accessories'});
        document.querySelector('#accessories').scrollIntoView();
        this.newOrderStoreService.changeLensSectionMode(LensSectionMode.ACCESSORIES);
    }

    goToConfirm() {
      this.router.navigate(['/new-order'], {fragment: 'order-confirm'});
      document.querySelector('#order-confirm').scrollIntoView();
      this.newOrderStoreService.setLensSectionMode(LensSectionMode.ORDER_CONFIRM);
    }

    isEnglish(): boolean {
        return this.languagePickerService.getLanguageCode() === 'en';
    }

    saveAndGoToHome(): void {
        this.newOrderStoreService.setCopyTrialLensRight(undefined);
        this.newOrderStoreService.setCopyTrialLensLeft(undefined);

        this.saveNewLensesAndItems();
      }

      private saveNewLensesAndItems() {
        let saveLenses: OrderItem[] = [];
        this.cartService.getCartItems().pipe(map(orderItems => orderItems.filter(orderItem => orderItem.isNew === true || orderItem.isUpdate === true))).subscribe(orderItems => saveLenses = orderItems);
        this.ordersApiService.updateCart({orderItems: saveLenses}).subscribe(response => {
          if(response.success) {
            this.messages.info("newOrder.messages.lensAdded");
            this.cartService.markLensesAsSaved();
          }
        });
      }
}
